import Footer from '../landing/components/Footer'
import PricingHero from './components/PricingHero'
import PricingTable from './components/PricingTable'
import PricingCTA from './components/PricingCTA'

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-oak-cream">
      <PricingHero />
      <PricingTable />
      <PricingCTA />
      <Footer />
    </div>
  )
}
